import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";
import type CompoundSurveyFrequency from "./compound-survey-frequency";

//---- Automatically generated, don't update this part ----

type SourceStringEnum = "profiler" | "wise";

/**
 * Represents the frequencies for all the enabled compound survey for this patient
 */
export default class CompoundSurveyFrequenciesChangedJournalEvent extends JournalEvent {
  static override type = "compound-survey-frequencies-changed-journal-event";

  @attr("string") declare source: SourceStringEnum;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.compound-survey-frequencies-changed-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      source: validateInclusion({
        list: ["profiler", "wise"],
        allowBlank: true,
        description: intl.t(
          "validations.compound-survey-frequencies-changed-journal-event.source"
        )
      })
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "compoundSurveyFrequenciesChangedJournalEvent"
  })
  declare patient: Patient;

  @attr("compound-survey-frequencies")
  declare enabledSurveyFrequencies: CompoundSurveyFrequency[];
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "compound-survey-frequencies-changed-journal-event": CompoundSurveyFrequenciesChangedJournalEvent;
  }
}
